import React from "react";
import {Form, Button, InputGroup, Col, Row, Card} from "react-bootstrap";
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {format, parse} from "date-fns";
import DatePicker from "react-datepicker";
import {connect} from "react-redux"
import "react-datepicker/dist/react-datepicker.css";
import { setLocations } from "./redux/reducers/app";
import {
  updateOrder as apiUpdateOrder,
  createOrder as apiCreateOrder,
} from "./utils/api";
import styled from 'styled-components';

import MapWithAddress from "./MapWithAddress";
import { MapAccordion } from "./MapAccordion";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { geocodeDeliveryPoint } from "./utils/locationUtils";
import { toast } from 'react-toastify';

const mapStateToProps = state => {
  return {
    companyId: state.app.companyId,
    companyIds: state.app.companyIds,
    locations: state.app.locations,
    customers: state.app.customersWeb,
    people: state.app.people
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLocations: (locations) => dispatch(setLocations(locations))
  }
}

function validate(inputs) {
  let rules = {
    locationId: isPresent(inputs.locationId) ? null : 'You must select a location',
    variantId: isPresent(inputs.variantId) ? null : 'You must select a product',
    quantity: inputs.quantity > 0 ? null : 'You must enter a quantity',
  }
  // Add rules for delivery
  if (inputs.carrierOrganisedBy === 'SAMI'){
    rules.deliveryDate = dateWarning(inputs.deliveryDate);
    rules.deliveryTime = isPresent(inputs.deliveryTime) ? null : 'You must select a time';
    
    const hasLatLng = inputs.lat != null && inputs.lng != null && 
                      isPresent(inputs.lat.toString()) && isPresent(inputs.lng.toString());
    rules.deliveryPoint = isPresent(inputs.deliveryPoint) || hasLatLng 
      ? null 
      : 'You must enter a delivery point or set location on the map';
    
    rules.tempRequired = temperatureWarning(inputs.tempRequired, inputs.productCategory);
    rules.loadDate = null;
    rules.loadTime = null;
  }
  // Add rules for pickup
  if (inputs.carrierOrganisedBy === 'Client'){
    rules.loadDate = dateWarning(inputs.loadDate);
    rules.loadTime = isPresent(inputs.loadTime) ? null : 'You must select a time';
    rules.deliveryDate = null;
    rules.deliveryTime = null;
    rules.deliveryPoint = null;
  }
  return rules;
}

function isPresent(value) {
  return value && value.length > 0;  
}

function temperatureWarning(value, category) {
  if (!value){
    return 'Please enter a temperature';
  }
  if (value && category) {
    if (category !== 'Emulsion' && (value < 20 || value > 195)){
      return 'Please enter a temperature between 20°C and 195°C';
    } else if (category === 'Emulsion' && value > 100)
    return 'Please enter a temperature less than 100°C';
    else {
      return null;
    }
  } else {
    return null;
  }
}

function dateWarning(date) {
  if (!date){
    return 'Please enter a date';
  }
  const today = new Date();
  today.setHours(0,0,0,0);

  if (date < today) {
    return 'Date cannot be earlier than today';
  } else {
    return null;
  }
}


const UnitOfMeasureOptions = (props) => {
  const loadType = props.loadType;
  if (loadType !== 'Packaged') {
    return (
      <React.Fragment>
        <option value='kg'>kg</option>
        <option value='L'>L</option>
      </React.Fragment>
    )
  } else {
    return (
      <option value='Units' disabled>Units</option>
    )
  }
}

// function for dynamic sorting
function compareValues(key, order='asc') {
  return function(a, b) {
    if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );
  };
}

const defaultMapCenter = {
  lat: -33.8688,
  lng: 151.2093
};

const getDeliveryPointGeoData = async (deliveryPoint) => {
  const geoData = await geocodeDeliveryPoint(deliveryPoint);
  if (geoData) {
    return {
      lat: geoData.lat,
      lng: geoData.lng
    }
  }
  return null;
}

// Wrapper around the lat / long fields and map accordion
const LocationCard = styled(Card)`
  margin: 1rem 0;
  background-color: transparent;
  
  .card-body {
    display: block;
    background-color: white;
    padding: 1rem;
    border: 1px solid var(--bs-border-color);
    border-radius: 6px;
  }
`;

class OrderForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      categories: [],
      variants: [],
      allProducts: [],
      carrierOrganisedBy: this.props.carrierPref || "SAMI",
      locationId: "",
      originalOrderID: "",
      productCategory: "",
      variantId: "",
      variantName: "",
      productSearchTerm: "",
      quantity: "",
      unitOfMeasure: "",
      varUnitOfMeasure: "",
      customerOrderNo: "",
      loadType: "",
      loadDate: "",
      loadDateDisplay: "",
      loadTime: "",
      deliveryDate: "",
      deliveryDateDisplay: "",
      deliveryTime: "",
      deliveryPoint: "",
      variantOptions: [],
      tempRequired: "",
      submitLabel: "",
      additive: "",
      kero: "",
      diesel: "",
      driversName: "",
      onsiteSupervisor: "",
      onsiteSprayer: "",
      lat: "",
      lng: "",
      showConfirmClear: false,
      errors: {
        locationId: "",
        productCategory: "",
        variantId: "",
        quantity: "",
        customerOrderNo: "",
        deliveryDate: "",
        deliveryTime: "",
        loadDate: "",
        loadTime: "",
        tempRequired: "",
      },
      touched: {
        locationId: "",
        productCategory: "",
        variantId: "",
        quantity: "",
        customerOrderNo: "",
        loadDate: "",
        loadTime: "",
        tempRequired: "",
        deliveryDate: "",
        deliveryTime: "",
        deliveryPoint: "",
      },
      mapCenter: defaultMapCenter,
    };
    this.updateOrder = this.updateOrder.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleDeliveryTimeBlur = this.handleDeliveryTimeBlur.bind(this);
    this.handleLoadTimeBlur = this.handleLoadTimeBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleProductFilterChange = this.handleProductFilterChange.bind(this);
    this.handleProductSelectChange = this.handleProductSelectChange.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.selectProduct = this.selectProduct.bind(this);
    this.getFilteredProducts = this.getFilteredProducts.bind(this);
    this.handleLoadDateChange = this.handleLoadDateChange.bind(this);
    this.handleLoadDateChangeNative = this.handleLoadDateChangeNative.bind(this);
    this.handleLoadTimeChange = this.handleLoadTimeChange.bind(this);
    this.handleDeliveryDateChange = this.handleDeliveryDateChange.bind(this);
    this.handleDeliveryDateChangeNative = this.handleDeliveryDateChangeNative.bind(this);
    this.handleDeliveryTimeChange = this.handleDeliveryTimeChange.bind(this);
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
    this.handleCarrierOrganisedBy = this.handleCarrierOrganisedBy.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSetLatLng = this.handleSetLatLng.bind(this);
    this.handleLatLongReset = this.handleLatLongReset.bind(this);
    this.handleConfirmClearLocation = this.handleConfirmClearLocation.bind(this);
  }


  componentDidMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
    let submitLabel = "Submit Order Request";
    let location,
      categories,
      variantOptions,
      formattedLoadDate,
      formattedLoadDateDisplay,
      formattedLoadTime,
      formattedDeliveryDate,
      formattedDeliveryDateDisplay,
      formattedDeliveryTime;
    let loadDate, loadTime, deliveryDate, deliveryTime;

    //populate data from order for editing existing orders
    if (this.props.mode === "edit") {
      submitLabel = "Submit Change Request";
      loadDate =
        this.props.order.fieldData["Order_CARRIERJOIN_depot_load::Load_Date"] ||
        "";
      loadTime =
        this.props.order.fieldData["Order_CARRIERJOIN_depot_load::Load_Time"] ||
        "";
      deliveryDate =
        this.props.order.fieldData[
          "Order_CARRIERJOIN_depot_load::Delivery_Date"
        ] || "";
      deliveryTime =
        this.props.order.fieldData[
          "Order_CARRIERJOIN_depot_load::Delivery_Time"
        ] || "";
    }

    if (this.props.mode === "edit" || this.props.mode === "duplicate") {
      let driverInstructions =
        this.props.order.fieldData["Driver_Instructions"] || "";
      let locationId = this.props.order.fieldData._fk_Location_UUID || "";
      let originalOrderID = "";
      if (this.props.mode === "duplicate") {
        originalOrderID = this.props.order.fieldData.__pk_Record_UUID || "";
      } else {
        originalOrderID = this.props.order.fieldData._fk_OriginalOrder_UUID || "";
      }
      let carrierOrganisedBy =
        this.props.order.fieldData[
          "Order_CARRIERJOIN_depot_load::Carrier_Organised_By"
        ] || "SAMI";
      let deliveryPoint =
        this.props.order.fieldData[
          "Order_CARRIERJOIN_depot_load::Delivery_Point"
        ] || "";
      let customerOrderNo =
        this.props.order.fieldData["Order_Number_Customer"] || "";
      let loadType = this.props.order.fieldData["Load_Type"] || "";
      let driversName =
        this.props.order.fieldData[
          "Order_CARRIERJOIN_depot_load::Driver_Name_ae"
        ] || "";
      let onsiteSupervisor =
        this.props.order.fieldData["OnSite_Supervisor"] || "";
      let onsiteSprayer = this.props.order.fieldData["OnSite_Sprayer"] || "";

      let lat = this.props.order.fieldData["Delivery_Lat"] || "";
      let lng = this.props.order.fieldData["Delivery_Lon"] || "";
      let geoLocType = "";
      if (this.props.mode === "edit") {
        geoLocType = this.props.order.fieldData["Delivery_Geolocation_type"] || "";
      } else {
        if (lat && lng) {
          geoLocType = "Duplicated in web portal";
        }
      }

      //line item specific
      let productId =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::_fk_Product_UUID"
        ] || "";
      let productCategory =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Product_Category"
        ] || "";
      let variantId =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::_fk_Variant_UUID_ae"
        ] || "";
      let variantName =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::ItemName_inc_Variant_c:"
        ] || "";
      let quantity =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Qty_Ordered"
        ] || "";
      let unitOfMeasure =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Unit_of_Measure_Short_ordered_ae"
        ] || "";
      let varUnitOfMeasure = "";
      let qtyPerUnit = null;
      let tempRequired =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Temp_Required"
        ] || "";
      let additive =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Additive_Required_Qty_ae"
        ] || "";
      let kero =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Cutback_Qty_Kero_ae"
        ] || "";
      let diesel =
        this.props.order.portalData.Order_ORDERLINE_web_create[0][
          "Order_ORDERLINE_web_create::Cutback_Qty_Diesel_ae"
        ] || "";

      if (loadDate && loadTime) {
        const timestamp = loadDate + " " + loadTime;
        formattedLoadDate = parse(loadDate, "MM/dd/yyyy", new Date());
        formattedLoadTime = format(
          parse(timestamp, "MM/dd/yyyy HH:mm:ss", new Date()),
          "HH:mm"
        );
        formattedLoadDateDisplay = format(formattedLoadDate, "yyyy-MM-dd");
      }

      if (deliveryDate && deliveryTime) {
        const timestamp = deliveryDate + " " + deliveryTime;
        formattedDeliveryDate = parse(deliveryDate, "MM/dd/yyyy", new Date());
        formattedDeliveryTime = format(
          parse(timestamp, "MM/dd/yyyy HH:mm:ss", new Date()),
          "HH:mm"
        );
        formattedDeliveryDateDisplay = format(
          formattedDeliveryDate,
          "yyyy-MM-dd"
        );
      }


      //check if we have a location id, and create the dependant state
      if (locationId) {
        location = this.props.locations.find(
          (item) => item.__pk_Record_UUID === locationId
        );
        if (!location) {
          console.log('location not found');
          throw new Error("No locations selected in existing order\nPlease contact SAMI for assistance.");
          return;
        }
        if (location?.Categories.indexOf(", ") > -1) {
          categories = location.Categories.split(", ");
        } else {
          categories = [location.Categories];
        }
        
        //check if we have a productCategory, and create the dependant state. Requires location.
        if (productCategory !== "") {
          variantOptions = location.Products.filter(
            (product) => product.Name_Category_ae === productCategory
          );
          if (variantOptions && Array.isArray(variantOptions)) {
            const variant = variantOptions.find(
              (item) => item['__pk_Record_UUID'] === variantId
            );
            if (variant) {
              varUnitOfMeasure = variant['Unit_of_Measure'];
              qtyPerUnit = variant['Qty_per_Unit'];
              variantName = variant['Product_Name_Variant_Name_c'];
            }  
          }
        }
      }
      

      this.setState({
        carrierOrganisedBy: carrierOrganisedBy,
        locationId: locationId,
        originalOrderID: originalOrderID,
        categories: categories || [],
        variants: variantOptions || [],
        allProducts: location?.Products || [],
        loadDate: formattedLoadDate || "",
        loadDateDisplay: formattedLoadDateDisplay || "",
        loadTime: formattedLoadTime || "",
        deliveryDate: formattedDeliveryDate || "",
        deliveryDateDisplay: formattedDeliveryDateDisplay || "",
        deliveryTime: formattedDeliveryTime || "",
        submitLabel: submitLabel,
        productId: productId,
        productCategory: productCategory,
        variantId: variantId,
        variantName: variantName,
        productSearchTerm: "",
        quantity: quantity,
        unitOfMeasure: unitOfMeasure,
        varUnitOfMeasure: varUnitOfMeasure,
        qtyPerUnit: qtyPerUnit,
        customerOrderNo: customerOrderNo,
        loadType: loadType,
        deliveryPoint: deliveryPoint,
        driverInstructions: driverInstructions,
        tempRequired: tempRequired,
        additive: additive,
        kero: kero,
        diesel: diesel,
        driversName: driversName,
        onsiteSupervisor: onsiteSupervisor,
        onsiteSprayer: onsiteSprayer,
        lat: lat,
        lng: lng,
        geoLocType: geoLocType,
      });
    } else if (this.props.mode === "new") {
      const deliveryPoint = this.props.deliveryPointDefault;
      this.setState({
        deliveryPoint: deliveryPoint,
        submitLabel: submitLabel,
      });
      //set defaults for new order where there's only one location
      if (this.props.locations.length === 1) {
        let locationId;
        locationId = this.props.locations[0]["__pk_Record_UUID"];
        categories = this.props.locations[0]["Categories"]
          .split(", ");
        
        const allProducts = this.props.locations[0].Products || [];
        
        // Auto-select category if there's only one
        let productCategory = '';
        let variants = [];
        if (categories.length === 1) {
          productCategory = categories[0];
          variants = this.props.locations[0].Products.filter(
            (product) => product.Name_Category_ae === productCategory
          );
          
          // Auto-select product if there's only one variant
          if (variants.length === 1) {
            const variant = variants[0];
            const variantId = variant['__pk_Record_UUID'];
            const productId = variant['_fk_Product_UUID'];
            const loadType = variant['Load_Type'];
            const unitOfMeasure = loadType === 'Packaged' ? 'Units' : variant['Unit_of_Measure'];
            const varUnitOfMeasure = variant['Unit_of_Measure'];
            const qtyPerUnit = variant['Qty_per_Unit'];
            const variantName = variant['Product_Name_Variant_Name_c'];
            
            this.setState({
              locationId: locationId,
              categories: categories || "",
              productCategory: productCategory,
              variants: variants,
              allProducts: allProducts,
              variantId: variantId,
              productId: productId,
              unitOfMeasure: unitOfMeasure,
              loadType: loadType,
              qtyPerUnit: qtyPerUnit,
              varUnitOfMeasure: varUnitOfMeasure,
              variantName: variantName,
              productSearchTerm: ""
            });
          } else {
            this.setState({
              locationId: locationId,
              categories: categories || "",
              productCategory: productCategory,
              variants: variants,
              allProducts: allProducts
            });
          }
        } else {
          this.setState({
            locationId: locationId,
            categories: categories || "",
            allProducts: allProducts
          });
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }
  
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  // **** HANDLE INPUT CHANGES **** //
  //use this to set touched for the input, to only show validation once field has been exited
  handleOnBlur(event){
    const name = event.target.name;
    this.setState({
      touched: {
        ...this.state.touched, 
        [name]: true
      }
    })
  }

  handleDeliveryTimeBlur(event) {
    const name = event.target.name;
    let value = event.target.value;
    
    // Round time to nearest 15 minutes for mobile native input
    if (name === 'deliveryTime' && value && event.target.type === 'time') {
      value = this.roundToNearest15Minutes(value);
      this.setState({ deliveryTime: value });
    }
    
    // Update touched state
    this.setState({
      touched: {
        ...this.state.touched,
        [name]: true
      }
    });
  }

  handleLoadTimeBlur(event) {
    const name = event.target.name;
    let value = event.target.value;
    
    // Round time to nearest 15 minutes for mobile native input
    if (name === 'loadTime' && value && event.target.type === 'time') {
      value = this.roundToNearest15Minutes(value);
      this.setState({ loadTime: value });
    }
    
    // Update touched state
    this.setState({
      touched: {
        ...this.state.touched,
        [name]: true
      }
    });
  }

  // Helper function to round time to nearest 15 minutes
  roundToNearest15Minutes(timeString) {
    if (!timeString) return timeString;
    
    // Parse the time string (HH:mm format)
    const [hours, minutes] = timeString.split(':').map(Number);
    
    // Round minutes to nearest 15
    const roundedMinutes = Math.round(minutes / 15) * 15;
    
    // Handle minute overflow (e.g., 59 minutes rounds to 60)
    let finalHours = hours;
    let finalMinutes = roundedMinutes;
    
    if (roundedMinutes === 60) {
      finalHours = (hours + 1) % 24;
      finalMinutes = 0;
    }
    
    // Format back to HH:mm
    return `${String(finalHours).padStart(2, '0')}:${String(finalMinutes).padStart(2, '0')}`;
  }

  handleInputChange(event) {
    //general handlerfor updaing the input value into state.
    //grab values from the input
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      touched: {
        ...this.state.touched, 
        [name]: true
      }
    })
  }

  handleLocationChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    
    if (!value) {
      // Location cleared
      this.setState({
        [name]: value,
        categories: [],
        productCategory: "",
        variants: [],
        allProducts: [],
        variantId: '',
        productId: '',
        unitOfMeasure: '',
        varUnitOfMeasure: '',
        loadType: '',
        productSearchTerm: ''
      });
      return;
    }
    
    const location = this.props.locations.find(item => item.__pk_Record_UUID === value);
    let categories = []
    if(location && Object.keys(location).length) {
      categories = location.Categories.split(', ');
    }else{
      categories = location.Categories;
    }

    const allProducts = location?.Products || [];

    // Auto-select category if there's only one
    let productCategory = '';
    let variants = [];
    if (categories.length === 1) {
      productCategory = categories[0];
      variants = location.Products.filter((product) => product.Name_Category_ae === productCategory);
      
      // Auto-select product if there's only one variant
      if (variants.length === 1) {
        const variant = variants[0];
        const variantId = variant['__pk_Record_UUID'];
        const productId = variant['_fk_Product_UUID'];
        const loadType = variant['Load_Type'];
        const unitOfMeasure = loadType === 'Packaged' ? 'Units' : variant['Unit_of_Measure'];
        const varUnitOfMeasure = variant['Unit_of_Measure'];
        const qtyPerUnit = variant['Qty_per_Unit'];
        const variantName = variant['Product_Name_Variant_Name_c'];
        
        this.setState({
          [name]: value,
          categories: categories,
          productCategory: productCategory,
          variants: variants,
          allProducts: allProducts,
          variantName: variantName,
          variantId: variantId,
          productId: productId,
          unitOfMeasure: unitOfMeasure,
          varUnitOfMeasure: varUnitOfMeasure,
          loadType: loadType,
          qtyPerUnit: qtyPerUnit,
          productSearchTerm: ""
        });
        return;
      }
    }

    this.setState({
      [name]: value,
      categories: categories,
      productCategory: productCategory,
      variants: variants,
      allProducts: allProducts,
      variantId: '',
      unitOfMeasure: '',
      varUnitOfMeasure: '',
      loadType: '',
      productSearchTerm: ''
    });
  }

  handleCategoryChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (!value) {
      // Category cleared - show all products, keep filter
      this.setState({
        [name]: value,
        variants: [],
        variantId: '',
        productId: '',
        unitOfMeasure: '',
        loadType: ''
        // productSearchTerm is NOT cleared
      });
      return;
    }

    const location = this.props.locations.find(item => item.__pk_Record_UUID === this.state.locationId);
    const category = value;
    let variants = location.Products.filter((product) => product.Name_Category_ae === category);

    // Auto-select product if there's only one variant
    if (variants.length === 1) {
      const variant = variants[0];
      const variantId = variant['__pk_Record_UUID'];
      const productId = variant['_fk_Product_UUID'];
      const loadType = variant['Load_Type'];
      const unitOfMeasure = loadType === 'Packaged' ? 'Units' : variant['Unit_of_Measure'];
      const varUnitOfMeasure = variant['Unit_of_Measure'];
      const qtyPerUnit = variant['Qty_per_Unit'];
      const variantName = variant['Product_Name_Variant_Name_c'];
      
      this.setState({
        [name]: value,
        variants: variants,
        variantId: variantId,
        productId: productId,
        unitOfMeasure: unitOfMeasure,
        loadType: loadType,
        qtyPerUnit: qtyPerUnit,
        varUnitOfMeasure: varUnitOfMeasure,
        variantName: variantName,
        productSearchTerm: variantName
      });
      return;
    }

    this.setState({
      [name]: value,
      variants: variants,
      variantId: '',
      productId: '',
      unitOfMeasure: '',
      loadType: ''
      // productSearchTerm is NOT cleared - keeps user's filter text
    });
  }

  // Extract product selection logic to avoid duplication
  selectProduct(matchedProduct) {
    const productCategory = matchedProduct.Name_Category_ae;
    const location = this.props.locations.find(item => item.__pk_Record_UUID === this.state.locationId);
    const variantsInCategory = location.Products.filter(
      product => product.Name_Category_ae === productCategory
    );

    const variantId = matchedProduct.__pk_Record_UUID;
    const productId = matchedProduct._fk_Product_UUID;
    const loadType = matchedProduct.Load_Type;
    const unitOfMeasure = loadType === 'Packaged' ? 'Units' : matchedProduct.Unit_of_Measure;
    const varUnitOfMeasure = matchedProduct.Unit_of_Measure;
    const qtyPerUnit = matchedProduct.Qty_per_Unit;
    const variantName = matchedProduct.Product_Name_Variant_Name_c;

    this.setState({
      productCategory: productCategory,
      variants: variantsInCategory,
      variantId: variantId,
      productId: productId,
      unitOfMeasure: unitOfMeasure,
      loadType: loadType,
      qtyPerUnit: qtyPerUnit,
      varUnitOfMeasure: varUnitOfMeasure,
      variantName: variantName,
      touched: {
        ...this.state.touched,
        variantId: false
      }
    });
  }

  handleProductFilterChange(event) {
    const value = event.target.value;
    
    this.setState({ 
      productSearchTerm: value
    });

    // Check if current selected product matches the new filter
    if (this.state.variantId) {
      const filteredProducts = this.getFilteredProducts();
      const currentProductStillVisible = filteredProducts.some(
        product => product.__pk_Record_UUID === this.state.variantId
      );

      // If the currently selected product is not in the filtered list, clear selection
      if (!currentProductStillVisible) {
        this.setState({
          variantId: '',
          productId: '',
          unitOfMeasure: '',
          loadType: '',
          qtyPerUnit: '',
          varUnitOfMeasure: '',
          variantName: '',
          touched: {
            ...this.state.touched,
            variantId: true
          }
        });
      }
    }
  }

  handleProductSelectChange(event) {
    const value = event.target.value;
    
    if (!value) {
      this.setState({
        variantId: '',
        productId: '',
        unitOfMeasure: '',
        loadType: '',
        qtyPerUnit: '',
        varUnitOfMeasure: '',
        variantName: '',
        touched: {
          ...this.state.touched,
          variantId: true
        }
      });
      return;
    }

    // Find the selected product
    let productsToSearch = this.state.productCategory 
      ? this.state.variants 
      : this.state.allProducts;

    const matchedProduct = productsToSearch.find(
      product => product.__pk_Record_UUID === value
    );

    if (matchedProduct) {
      this.selectProduct(matchedProduct);
    }
  }

  handleClearFilter = () => {
    this.setState({
      productSearchTerm: ''
    });
  }

  // Filter products based on search term
  getFilteredProducts = () => {
    if (!this.state.locationId) return [];
    
    let productsToSearch = this.state.productCategory 
      ? this.state.variants 
      : this.state.allProducts;

    if (!this.state.productSearchTerm) {
      return productsToSearch;
    }

    const searchTerms = this.state.productSearchTerm.toLowerCase().split(' ').filter(term => term.length > 0);
    
    return productsToSearch.filter(product => {
      const productName = product.Product_Name_Variant_Name_c.toLowerCase();
      // All search terms must be found in the product name
      return searchTerms.every(term => productName.includes(term));
    });
  }

  handleLoadDateChange(date) {
    this.setState({
      loadDate: date
    });
  }

  handleLoadDateChangeNative(event) {
    let value = event.target.value;
    if (value){ 
      const dateNew = parse(value, 'yyyy-MM-dd', new Date());
      this.setState({
        loadDate: dateNew,
        loadDateDisplay: value
      });
    }
  }

  handleLoadTimeChange(date) {
    if (!date) {
      this.setState({ loadTime: '' });
      return;
    }
    
    // Convert Date to HH:mm string and round to nearest 15 minutes
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const timeString = `${hours}:${minutes}`;
    const roundedTime = this.roundToNearest15Minutes(timeString);
    
    this.setState({
      loadTime: roundedTime,
      touched: {
        ...this.state.touched,
        loadTime: true
      }
    });
  }

  handleDeliveryDateChange(date) {
    this.setState({
      deliveryDate: date
    });
  }

  handleDeliveryDateChangeNative(event) {
    let value = event.target.value;
    if (!value){ return }
    const dateNew = parse(value, 'yyyy-MM-dd', new Date());
    this.setState({
      deliveryDate: dateNew,
      deliveryDateDisplay: value
    });
  }

  handleDeliveryTimeChange(date) {
    if (!date) {
      this.setState({ deliveryTime: '' });
      return;
    }
    
    // Convert Date to HH:mm string and round to nearest 15 minutes
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const timeString = `${hours}:${minutes}`;
    const roundedTime = this.roundToNearest15Minutes(timeString);
    
    this.setState({
      deliveryTime: roundedTime,
      touched: {
        ...this.state.touched,
        deliveryTime: true
      }
    });
  }

  handleCarrierOrganisedBy(value) {
    //set the CarrierOrganisedBy, clear the other date and time values
    if (value === 'SAMI') {
      this.setState({
        carrierOrganisedBy: value,
        loadDate: '',
        loadDateDisplay: '',
        loadTime: ''
      });
    } else if (value === 'Client') {
      this.setState({
        carrierOrganisedBy: value,
        deliveryDate: '',
        deliveryDateDisplay: '',
        deliveryTime: ''
      });
    }
  }

  updateOrder = async (mode, recordId, data) => {
    if (!data || !mode) {
      console.log('missing arguments for updateOrder()');
      return;
    }

    if (mode === 'edit') {
      return apiUpdateOrder(recordId, data)
        .then((body) => {
          if (body?.message === "OK") {
            this.props.onHide();
          } else {
            this.setState({
              submitLabel: "Submit Change Request",
            });
            toast.error(body?.message);
          }
        })
        .catch((res) => {
          console.log(res.error);
        });
    } else if (mode === 'new' || mode === 'duplicate') {
      return apiCreateOrder(data)
        .then((body) => {
          if (body.message === "OK") {
            this.props.onHide();
          } else {
            this.setState({
              submitLabel: "Submit Order Request",
            });
            toast.error(body?.message);
          }
          return body;
        })
        .catch((body) => {
          console.log(body);
        });
    }
  }


  handleSubmit(event) {
    event.preventDefault();
    //touched object to set all fields to touched to assist with validation
    const touchedAll =  {
      locationId: true,
      productCategory: true,
      variantId: true,
      quantity: true,
      customerOrderNo: true,
      loadDate: true,
      loadTime: true,
      tempRequired: true,
      deliveryDate: true,
      deliveryTime: true,
      deliveryPoint: true,
    };

    // Check form for errors
    let errors = validate({
      locationId: this.state.locationId,
      productCategory: this.state.productCategory,
      variantId: this.state.variantId,
      quantity: this.state.quantity,
      carrierOrganisedBy: this.state.carrierOrganisedBy,
      tempRequired: this.state.tempRequired,
      deliveryDate: this.state.deliveryDate,
      deliveryTime: this.state.deliveryTime,
      deliveryPoint: this.state.deliveryPoint,
      loadDate: this.state.loadDate,
      loadTime: this.state.loadTime,
      lat: this.state.lat,
      lng: this.state.lng
    });

    const anyError = Object.keys(errors).some(x => errors[x]);
    if (anyError) {
      console.log(errors);
      this.setState({ 
        errors: errors,
        touched: touchedAll
      });
      return;
    }

    if (this.state.submitLabel !== 'Submitting...') {
      this.setState({
        submitLabel: 'Submitting...',
      });
      
      const SMSType = (this.props.mode === 'new' || this.props.mode === 'duplicate') ? 'New' : 'Update';
      
      const body = {
        "fieldData": {
          'Flag_Web': 1,
          'Flag_Requested_Web' : 1,
          'z_autoEnterTrigger' : 1,
          'SMS_Type_Required' : SMSType,
          '_fk_OriginalOrder_UUID': this.state.originalOrderID,
          'Order_Number_Customer': this.state.customerOrderNo,
          'Date_Order' : format(Date.now(), 'MM/dd/yyyy'),
          '_fk_Location_UUID' : this.state.locationId,
          '_fk_Customer_UUID': this.props.companyId,
          'Load_Type' : this.state.loadType,
          'Driver_Instructions' : this.state.driverInstructions || '',
          'Requested_Account_Name' : this.props.userFullName || '',
          'Date_Loaded_ae' : this.state.loadDate && format(this.state.loadDate, 'MM/dd/yyyy' ),
          'OnSite_Supervisor' : this.state.onsiteSupervisor,
          'OnSite_Sprayer' : this.state.onsiteSprayer,
          'Delivery_Lat' : this.state.lat,
          'Delivery_Lon' : this.state.lng,
          'Delivery_Geolocation_type' : this.state.geoLocType,
          //carrier data
          'Order_CARRIERJOIN_depot_load::Carrier_Organised_By': this.state.carrierOrganisedBy,
          'Order_CARRIERJOIN_depot_load::Load_Date' : this.state.loadDate && format(this.state.loadDate, 'MM/dd/yyyy' ),
          "Order_CARRIERJOIN_depot_load::Load_Time" : this.state.loadTime,
          "Order_CARRIERJOIN_depot_load::Delivery_Date" : this.state.deliveryDate && format(this.state.deliveryDate, 'MM/dd/yyyy' ),
          "Order_CARRIERJOIN_depot_load::Delivery_Time" : this.state.deliveryTime,
          "Order_CARRIERJOIN_depot_load::Delivery_Point" : this.state.deliveryPoint,
          "Order_CARRIERJOIN_depot_load::Driver_Name_ae" : this.state.driversName
        },
        "portalData": {
          "Order_ORDERLINE_web_create" : [{
            "Order_ORDERLINE_web_create::_fk_Location_UUID": this.state.locationId,
            "Order_ORDERLINE_web_create::Product_Category": this.state.productCategory,
            "Order_ORDERLINE_web_create::_fk_Product_UUID": this.state.productId,
            "Order_ORDERLINE_web_create::_fk_Variant_UUID_ae": this.state.variantId,
            "Order_ORDERLINE_web_create::Qty_Ordered": this.state.quantity,
            "Order_ORDERLINE_web_create::Temp_Required": this.state.tempRequired,
            "Order_ORDERLINE_web_create::Unit_of_Measure_Short_ordered_ae": this.state.unitOfMeasure,
            "Order_ORDERLINE_web_create::Order_Load_Type_ae" : this.state.loadType,
            "Order_ORDERLINE_web_create::Additive_Required_Qty_ae" : this.state.additive,
            "Order_ORDERLINE_web_create::Cutback_Qty_Kero_ae" : this.state.kero,
            "Order_ORDERLINE_web_create::Cutback_Qty_Diesel_ae" : this.state.diesel,
          }]
      
        } 
      }  
      //if the order is an edit, add in the recordId to portals
      if(this.props.mode === 'edit') {
        body.portalData.Order_ORDERLINE_web_create[0].recordId = this.props.order.portalData.Order_ORDERLINE_web_create[0].recordId;
      }
      
      this.updateOrder(this.props.mode, this.props.order['recordId'], body);
    }
  }

  handleSetLatLng(lat, lng) {
    this.setState({
      lat: Number(lat.toFixed(6)),
      lng: Number(lng.toFixed(6)),
      geoLocType: "Dropped pin in web portal"
    });
  }

  // **** RENDER INPUT OPTIONS **** //
  locationOptions = location => {
    const location_id = location.__pk_Record_UUID;
    const location_name = location.Name
    
    // Make sure the location is loaded before we continue!
    if (!location) return null;

    return (
      <option key={`location_${location_id}`} value={location_id}>{location_name}</option>
    );
  };


  categoryOptions = (category,) => {
    // Make sure the category is loaded before we continue!
    if (!category) return null;
    return (
        <option key={category} value={category}>{category}</option>
    );
  };

  peopleOnsiteOptions = person => {
    const value = person['Name_First'] + ' ' + person['Name_Last'] + ': ' + person['Phone_Mobile'];
    if (!person) return null;
    return (
        <option key={value} value={value}>{value}</option>
    );
  };

  async getMapCenter() {
    if (this.state.lat && this.state.lng) {
      return {
        lat: this.state.lat,
        lng: this.state.lng
      };
    }

    if (this.state.deliveryPoint) {
      try {
        const geoData = await getDeliveryPointGeoData(this.state.deliveryPoint);
        if (geoData?.lat && geoData?.lng) {
          return {
            lat: geoData.lat,
            lng: geoData.lng
          };
        }
      } catch (error) {
        console.error('Error getting geo data:', error);
      }
    }

    return defaultMapCenter;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.lat !== this.state.lat ||
      prevState.lng !== this.state.lng 
    ) {
      this.getMapCenter().then(newCenter => {
        this.setState({ mapCenter: newCenter });
      });
    }
  }

  handleDeliveryPointBlur = async (event) => {
    this.handleOnBlur(event);
    
    if (this.state.deliveryPoint) {
      const newCenter = await this.getMapCenter();
      this.setState({ mapCenter: newCenter });
    }
  };

  handleLatLongReset = () => {
    this.setState({
      showConfirmClear: true
    });
  }

  handleConfirmClearLocation = () => {
    this.setState({
      lat: null,
      lng: null,
      geoLocType: null,
      showConfirmClear: false
    });
  }

  render() {

    const { width } = this.state;
    const companyData = this.props.customers.find((el) => el.__pk_Record_UUID === this.props.companyId)
    this.props.setLocations(companyData.Locations);

    const hasOnlyOneLocation = this.props.locations && this.props.locations.length === 1;
    const hasOnlyOneCategory = this.state.categories && this.state.categories.length === 1;
    
    const errors = validate({
      locationId: this.state.locationId,
      productCategory: this.state.productCategory,
      variantId: this.state.variantId,
      quantity: this.state.quantity,
      carrierOrganisedBy: this.state.carrierOrganisedBy,
      tempRequired: this.state.tempRequired,
      deliveryDate: this.state.deliveryDate,
      deliveryTime: this.state.deliveryTime,
      deliveryPoint: this.state.deliveryPoint,
      loadDate: this.state.loadDate,
      loadTime: this.state.loadTime,
      lat: this.state.lat,
      lng: this.state.lng,
      geoLocType: this.state.geoLocType
      });

    return (
      <>
      <Form onSubmit={this.handleSubmit}>
        {/* Location */}
        <Form.Group className="mb-3">
          <Form.Label>From Location:*</Form.Label>
          <Form.Select
            name="locationId"
            value={this.state.locationId}
            onChange={this.handleLocationChange}
            onBlur={this.handleOnBlur}
            disabled={hasOnlyOneLocation}
            required
          >
            {!hasOnlyOneLocation && (
              <option value="">
                {" "}
                -- select an option --{" "}
              </option>
            )}
            {this.props.locations.map(this.locationOptions)}
          </Form.Select>
          {errors.locationId && this.state.touched.locationId ? (
            <p className="form-error-message">{errors.locationId}</p>
          ) : null}
        </Form.Group>

        {/* Product Category - Optional */}
        <Form.Group className="mb-3">
          <Form.Label>Product Category:</Form.Label>
          <Form.Select
            name="productCategory"
            value={this.state.productCategory}
            onChange={this.handleCategoryChange}
            onBlur={this.handleOnBlur}
            disabled={!this.state.locationId || hasOnlyOneCategory}
          >
            <option value="">
              {" "}
              -- all categories --{" "}
            </option>
            {this.state.categories.map(this.categoryOptions)}
          </Form.Select>
        </Form.Group>

        {/* Product Filter and Dropdown */}
        <Form.Group className="mb-3">
          <Form.Label>Product:*</Form.Label>
          
          {/* Filter Input */}
          <InputGroup className="mb-2">
            <InputGroup.Text>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 3h20L14 12v7l-4 2V12L2 3z"/>
              </svg>
            </InputGroup.Text>
            <Form.Control
              type="text"
              name="productSearchTerm"
              placeholder="Type to filter products..."
              value={this.state.productSearchTerm}
              onChange={this.handleProductFilterChange}
              disabled={!this.state.locationId}
              autoComplete="off"
            />
            {this.state.productSearchTerm && (
              <Button 
                variant="outline-secondary"
                onClick={this.handleClearFilter}
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </Button>
            )}
          </InputGroup>

          {/* Product Dropdown */}
          <Form.Select
            name="variantId"
            value={this.state.variantId}
            onChange={this.handleProductSelectChange}
            onBlur={this.handleOnBlur}
            disabled={!this.state.locationId}
            required
          >
            <option value="">
              {" "}
              -- select a product --{" "}
            </option>
            {!this.state.productCategory ? (
              // Grouped by category when no category is selected
              (() => {
                const filteredProducts = this.getFilteredProducts();
                const groupedByCategory = filteredProducts.reduce((acc, product) => {
                  const category = product.Name_Category_ae;
                  if (!acc[category]) acc[category] = [];
                  acc[category].push(product);
                  return acc;
                }, {});

                return Object.keys(groupedByCategory)
                  .sort()
                  .map(category => (
                    <optgroup key={category} label={category}>
                      {groupedByCategory[category]
                        .sort((a, b) => a.Product_Name_Variant_Name_c.localeCompare(b.Product_Name_Variant_Name_c))
                        .map(variant => (
                          <option 
                            key={variant.__pk_Record_UUID} 
                            value={variant.__pk_Record_UUID}
                          >
                            {variant.Product_Name_Variant_Name_c}
                          </option>
                        ))}
                    </optgroup>
                  ));
              })()
            ) : (
              // Flat list when category is selected
              this.getFilteredProducts()
                .sort((a, b) => a.Product_Name_Variant_Name_c.localeCompare(b.Product_Name_Variant_Name_c))
                .map(variant => (
                  <option 
                    key={variant.__pk_Record_UUID} 
                    value={variant.__pk_Record_UUID}
                  >
                    {variant.Product_Name_Variant_Name_c}
                  </option>
                ))
            )}
          </Form.Select>
          
          {errors.variantId && this.state.touched.variantId ? (
            <p className="form-error-message">{errors.variantId}</p>
          ) : null}
        </Form.Group>

        {/* Quantity */}
        <Form.Group className="mb-3">
          <Form.Label>Quantity:*</Form.Label>
          <Row>
            <Col xs={12} sm={6}>
              <InputGroup>
                <Form.Control
                  name="quantity"
                  type="number"
                  min = "1"
                  step = "1"
                  pattern="[1-9][0-9]*"
                  value={this.state.quantity}
                  onChange={this.handleInputChange}
                  onBlur={this.handleOnBlur}
                  autoComplete="off"
                  required
                />
                <InputGroup.Text>
                  <Form.Select
                    name="unitOfMeasure"
                    value={this.state.unitOfMeasure}
                    onChange={this.handleInputChange}
                    required
                  >
                    <UnitOfMeasureOptions loadType={this.state.loadType} />
                  </Form.Select>
                </InputGroup.Text>
              </InputGroup>
              {errors.quantity && this.state.touched.quantity ? (
                <p className="form-error-message">{errors.quantity}</p>
              ) : null}
            </Col>
            {this.state.loadType === "Packaged" && this.state.quantity > 0 && this.state.qtyPerUnit > 0 && Number(this.state.quantity) % 1 === 0 ? (
            <Col style={{ display: 'flex', alignItems: 'center' }}>
              <Form.Label>Total: {Number(this.state.quantity) * Number(this.state.qtyPerUnit)} {this.state.varUnitOfMeasure}</Form.Label>
            </Col>
            ): null}
          </Row>
        </Form.Group>

        {/* Additives - only when load type is bulk */}
        {this.state.loadType === "Bulk" ? (
          <Form.Group className="mb-3">
            <Row>
              <Col xs={4}>
                <Form.Label>Additive:</Form.Label>
                <InputGroup>
                  <Form.Control
                    name="additive"
                    type="number"
                    min = "0"
                    step = "1"
                    pattern="[0-9]+"
                    autoComplete="off"
                    value={this.state.additive}
                    onChange={this.handleInputChange}
                    onBlur={this.handleOnBlur}
                  />
                  <InputGroup.Text>kg</InputGroup.Text>
                </InputGroup>
              </Col>

              <Col xs={4}>
                <Form.Label>Kero:</Form.Label>
                <InputGroup>
                  <Form.Control
                    name="kero"
                    type="number"
                    min = "0"
                    step = "1"
                    pattern="[0-9]+"
                    autoComplete="off"
                    value={this.state.kero}
                    onChange={this.handleInputChange}
                    onBlur={this.handleOnBlur}
                  />
                  <InputGroup.Text>L</InputGroup.Text>
                </InputGroup>
              </Col>

              <Col xs={4}>
                <Form.Label>Diesel:</Form.Label>
                <InputGroup>
                  <Form.Control
                    name="diesel"
                    type="number"
                    min = "0"
                    step = "1"
                    pattern="[0-9]+"
                    autoComplete="off"
                    value={this.state.diesel}
                    onChange={this.handleInputChange}
                    onBlur={this.handleOnBlur}
                  />
                  <InputGroup.Text>L</InputGroup.Text>
                </InputGroup>
              </Col>
            </Row>
          </Form.Group>
        ) : (
          ""
        )}

        <hr />

        {/* Customer Order Number */}
        <Form.Group className="mb-3">
          <Form.Label>Your Order Number:</Form.Label>
          <Form.Control
            name="customerOrderNo"
            type="text"
            autoComplete="off"
            value={this.state.customerOrderNo}
            onChange={this.handleInputChange}
            onBlur={this.handleOnBlur}
          />
        </Form.Group>

        {/* Delivery or Pickup Option */}
        <ToggleButtonGroup
        type="radio"
        name="carrierOrganisedBy"
        value={this.state.carrierOrganisedBy}
        onChange={this.handleCarrierOrganisedBy}
        className="btn-group-toggle"
      >
        <ToggleButton id="tbg-radio-1" value="SAMI">
          Delivery
        </ToggleButton>
        <ToggleButton id="tbg-radio-2" value="Client">
          Pick-up
        </ToggleButton>
      </ToggleButtonGroup>
        {errors.carrierOrganisedBy && this.state.touched.carrierOrganisedBy ? (
          <p className="form-error-message">{errors.carrierOrganisedBy}</p>
        ) : null}

        {this.state.carrierOrganisedBy === "SAMI" ? (
          /* DELIVERY FIELDS*/
          <div>
            <Form.Group className="mb-3">
              <Form.Label>Delivery Point:*</Form.Label>
              <Form.Control
                as="textarea"
                name="deliveryPoint"
                value={this.state.deliveryPoint}
                onChange={this.handleInputChange}
                onBlur={this.handleDeliveryPointBlur}
                required={!this.state.lat || !this.state.lng}
              />
              {errors.deliveryPoint && this.state.touched.deliveryPoint ? (
                <p className="form-error-message">{errors.deliveryPoint}</p>
              ) : null}
            </Form.Group>

            {/* Lat and long fields - use the map to update these */}
            <LocationCard>
              <Card.Body className="position-relative">
                <a 
                  href="#" 
                  onClick={this.handleLatLongReset}
                  className="reset-lat-long-link btn btn-sm btn-outline-secondary"
                >
                  Clear Lat/Long
                </a>
                <Form.Group className="lat-long-field-group">
                  <Row>
                  <Col>
                    <Form.Label>Latitude:</Form.Label>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Use the map to update this field</Tooltip>}
                    >
                      <Form.Control
                        name="lat"
                        type="text"
                        value={this.state.lat ?? ''}
                        disabled
                        />
                    </OverlayTrigger>
                  </Col>
                  <Col>
                    <Form.Label>Longitude:</Form.Label>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Use the map to update this field</Tooltip>}
                    >
                      <Form.Control
                        name="lng"
                        type="text"
                        value={this.state.lng ?? ''}
                        disabled
                        />
                      </OverlayTrigger>
                  </Col>
                </Row>
              </Form.Group>


              <MapAccordion>
                <MapWithAddress
                  defaultCenter={this.state.mapCenter}
                  lat={this.state.lat}
                  lng={this.state.lng}
                  handleSetLatLng={this.handleSetLatLng}
                />
              </MapAccordion>
              </Card.Body>
            </LocationCard>

            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Label>Delivery Date:*</Form.Label>
                  {width <= 576 ? (
                    <Form.Control
                      name="deliveryDate"
                      type="date"
                      dateFormat="dd/MM/yyyy"
                      autoComplete="off"
                      value={this.state.deliveryDateDisplay}
                      onChange={this.handleDeliveryDateChangeNative}
                      onBlur={this.handleOnBlur}
                      placeholder="DD/MM/YYYY"
                    />
                  ) : (
                    <DatePicker
                      name="deliveryDate"
                      type="date"
                      className="form-control block"
                      dateFormat="dd/MM/yyyy"
                      autoComplete="off"
                      selected={this.state.deliveryDate}
                      onChange={this.handleDeliveryDateChange}
                      onBlur={this.handleOnBlur}
                    />
                  )}
                  {errors.deliveryDate && this.state.touched.deliveryDate ? (
                    <p className="form-error-message">{errors.deliveryDate}</p>
                  ) : null}
                </Col>
                <Col>
                  <Form.Label>Delivery Time:*</Form.Label>
                  {width <= 576 ? (
                    <>
                    <Form.Control
                      name="deliveryTime"
                      type="time"
                      autoComplete="off"
                      value={this.state.deliveryTime}
                      onChange={this.handleInputChange}
                      onBlur={this.handleDeliveryTimeBlur}
                      placeholder="HH:MM"
                      step="900"
                    />
                    <p className="form-text text-muted">Rounded to 15 mins</p>
                    </>
                  ) : (
                    <DatePicker
                      name="deliveryTime"
                      className="form-control block"
                      autoComplete="off"
                      selected={this.state.deliveryTime ? parse(this.state.deliveryTime, 'HH:mm', new Date()) : null}
                      onChange={this.handleDeliveryTimeChange}
                      onBlur={this.handleOnBlur}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="HH:MM"
                    />
                  )}
                  {errors.deliveryTime && this.state.touched.deliveryTime ? (
                    <p className="form-error-message">{errors.deliveryTime}</p>
                  ) : null}
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Temperature Required:*</Form.Label>
              <InputGroup className="input-half">
                <Form.Control
                  name="tempRequired"
                  type="number"
                  autoComplete="off"
                  value={this.state.tempRequired}
                  onChange={this.handleInputChange}
                  onBlur={this.handleOnBlur}
                />
                <InputGroup.Text id="inputGroupAppend">°C</InputGroup.Text>
              </InputGroup>
              {errors.tempRequired && this.state.touched.tempRequired ? (
                <p className="form-error-message">{errors.tempRequired}</p>
              ) : null}
            </Form.Group>

            {/* Onsite Supervisor */}
            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Label>Onsite Supervisor:</Form.Label>
                  <Form.Select
                    name="onsiteSupervisor"
                    value={this.state.onsiteSupervisor}
                    onChange={this.handleInputChange}
                  >
                    <option selected value>
                      {" "}
                      -- select an option --{" "}
                    </option>
                    {Array.isArray(this.props.people) && this.props.people.map(this.peopleOnsiteOptions)}
                    </Form.Select>
                </Col>
                {/* Onsite Sprayer */}
                <Col>
                  <Form.Label>Onsite Sprayer:</Form.Label>
                  <Form.Select
                    as="select"
                    name="onsiteSprayer"
                    value={this.state.onsiteSprayer}
                    onChange={this.handleInputChange}
                  >
                    <option selected value>
                      {" "}
                      -- select an option --{" "}
                    </option>
                    {this.props.people.map(this.peopleOnsiteOptions)}
                  </Form.Select>
                </Col>
              </Row>
            </Form.Group>
          </div>
        ) : (
          <>
            {/* PICKUP FIELDS*/
            /* Load Date and Time*/}
            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Label>Load Date:*</Form.Label>
                  {width <= 576 ? (
                    <Form.Control
                      name="loadDate"
                      type="date"
                      dateFormat="dd/MM/yyyy"
                      autoComplete="off"
                      value={this.state.loadDateDisplay}
                      onChange={this.handleLoadDateChangeNative}
                      onBlur={this.handleOnBlur}
                      placeholder="YYYY-MM-DD"
                    />
                  ) : (
                    <DatePicker
                      name="loadDate"
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      autoComplete="off"
                      selected={this.state.loadDate}
                      onChange={this.handleLoadDateChange}
                      onBlur={this.handleOnBlur}
                    />
                  )}
                  {errors.loadDate && this.state.touched.loadDate ? (
                    <p className="form-error-message">{errors.loadDate}</p>
                  ) : null}
                </Col>
                <Col>
                  <Form.Label>Load Time:*</Form.Label>
                  {width <= 576 ? (
                    <>
                      <Form.Control
                        name="loadTime"
                        type="time"
                        autoComplete="off"
                        value={this.state.loadTime}
                        onChange={this.handleInputChange}
                        onBlur={this.handleLoadTimeBlur}
                        placeholder="HH:MM"
                        step="900"
                      />
                      <p className="form-text text-muted">Rounded to 15 mins</p>
                    </>
                  ) : (
                    <DatePicker
                      name="loadTime"
                      className="form-control block"
                      autoComplete="off"
                      selected={this.state.loadTime ? parse(this.state.loadTime, 'HH:mm', new Date()) : null}
                      onChange={this.handleLoadTimeChange}
                      onBlur={this.handleOnBlur}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="HH:MM"
                    />
                  )}
                  {errors.loadTime && this.state.touched.loadTime ? (
                    <p className="form-error-message">{errors.loadTime}</p>
                  ) : null}
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Temperature Required:</Form.Label>
              <InputGroup className="input-half">
                <Form.Control
                  name="tempRequired"
                  type="number"
                  autoComplete="off"
                  value={this.state.tempRequired}
                  onChange={this.handleInputChange}
                  onBlur={this.handleOnBlur}
                />
                <InputGroup.Text id="inputGroupAppend">°C</InputGroup.Text>
              </InputGroup>
              {errors.tempRequired && this.state.touched.tempRequired ? (
                <p className="form-error-message">{errors.tempRequired}</p>
              ) : null}
            </Form.Group>
          </>
        )}

        {/* Drivers Name */}
        <Form.Group className="mb-3">
          <Form.Label>Drivers Name:</Form.Label>
          <Form.Control
            name="driversName"
            type="text"
            autoComplete="on"
            value={this.state.driversName}
            onChange={this.handleInputChange}
            onBlur={this.handleOnBlur}
          />
        </Form.Group>

        {/* Driver Instructions */}
        <Form.Group className="mb-3">
          <Form.Label>Driver Instructions:</Form.Label>
          <Form.Control
            as="textarea"
            name="driverInstructions"
            value={this.state.driverInstructions}
            onChange={this.handleInputChange}
            onBlur={this.handleOnBlur}
          />
        </Form.Group>

        <Button variant="primary" type="submit">
          {this.state.submitLabel}
        </Button>
      </Form>

      <Offcanvas 
        show={this.state.showConfirmClear} 
        onHide={() => this.setState({ showConfirmClear: false })}
        placement="bottom"
        style={{ height: 'auto' }}
        className=""
      >
      <Offcanvas.Header closeButton closeVariant={"white"}>
        <Offcanvas.Title>Confirm Clear Location</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <p>Are you sure you want to clear the selected lat/long? You'll be able to select a new location on the map.</p>
        <div className="d-flex justify-content-end gap-2">
          <Button 
            variant="secondary" 
            onClick={() => this.setState({ showConfirmClear: false })}
          >
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={this.handleConfirmClearLocation}
          >
            Clear Location
          </Button>
        </div>
      </Offcanvas.Body>
      </Offcanvas>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderForm);